// angular
import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
// api
import {CommonsModule} from '../commons/commons.module';
import {ApiConfig} from './api-config';
import {SmagApiService} from './smag-api.service';
import {AuthModule} from 'auth-commons';
import {HttpErrorInterceptor} from './http-error-interceptor.service';
import {GoogleApiService} from './google-api.service';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        CommonsModule,
        AuthModule
    ],
    declarations: []
})
export class ApiModule {

    /**
     * Configures the ApiModule.
     *
     * @param config Module configuration
     * @return The module with the providers
     */
    static forRoot(config: ApiConfig): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [
                {provide: ApiConfig, useValue: config},
                GoogleApiService,
                SmagApiService,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: HttpErrorInterceptor,
                    multi: true
                }
            ]
        };
    }
}
